// Help content, FAQs and downloadable templates for the onboarding application, RFIs and
// periodic refresh forms live on docs.anchorage.com under Account verification (ONMON-5671).
// Content owners update those pages directly; these URLs stay stable so forms need no changes.
const ACCOUNT_VERIFICATION_DOCS_URL =
  'https://docs.anchorage.com/knowledge-base/platform/users/web-dashboard/account-verification';

export const ACCOUNT_VERIFICATION_DOCS = {
  onboardingRequirements: `${ACCOUNT_VERIFICATION_DOCS_URL}/onboarding-requirements#onboarding-requirements`,
  beneficialOwnershipCertification: `${ACCOUNT_VERIFICATION_DOCS_URL}/ownership#beneficial-ownership-certification`,
  ownershipStructureDiagram: `${ACCOUNT_VERIFICATION_DOCS_URL}/ownership#ownership-structure-diagram`,
  boardResolution: `${ACCOUNT_VERIFICATION_DOCS_URL}/ownership#board-resolution`,
  amlProgram: `${ACCOUNT_VERIFICATION_DOCS_URL}/aml-program#what-is-an-aml-program`,
  amlQuestionnaire: `${ACCOUNT_VERIFICATION_DOCS_URL}/aml-program#aml-questionnaire`,
  accreditedInvestor: `${ACCOUNT_VERIFICATION_DOCS_URL}/accredited-investor`,
  accreditedInvestorDisclosures: `${ACCOUNT_VERIFICATION_DOCS_URL}/accredited-investor#what-do-i-acknowledge-and-agree-to`,
  eligibleContractParticipant: `${ACCOUNT_VERIFICATION_DOCS_URL}/trading-eligibility#eligible-contract-participant-ecp`,
  acceptableEcpEvidence: `${ACCOUNT_VERIFICATION_DOCS_URL}/trading-eligibility#acceptable-ecp-evidence`,
  tradingAuthorization: `${ACCOUNT_VERIFICATION_DOCS_URL}/trading-eligibility#trading-authorization`,
  firmTradingAuthorizationForm: `${ACCOUNT_VERIFICATION_DOCS_URL}/trading-eligibility#firm-trading-authorization-form`,
} as const;

export const TAX_CERTIFICATION_FAQ_URL =
  'https://docs.anchorage.com/knowledge-base/platform/users/web-dashboard/tax-certification-faq';

// KYC_DOCS_BY_HREF_ID maps the `<customlink id="...">` ids used in question
// copy to their docs page. Links to these pages open in a new tab so the client keeps their place.
export const KYC_DOCS_BY_HREF_ID: Record<string, string> = {
  'faq-beneficial-ownership-certification':
    ACCOUNT_VERIFICATION_DOCS.beneficialOwnershipCertification,
  'faq-ownership-diagram': ACCOUNT_VERIFICATION_DOCS.ownershipStructureDiagram,
  'faq-intermediary-layers':
    ACCOUNT_VERIFICATION_DOCS.ownershipStructureDiagram,
  'sample-board-resolution': ACCOUNT_VERIFICATION_DOCS.boardResolution,
  'faq-aml-program': ACCOUNT_VERIFICATION_DOCS.amlProgram,
  'aml-questionnaire': ACCOUNT_VERIFICATION_DOCS.amlQuestionnaire,
  'faq-accredited-investor-certification':
    ACCOUNT_VERIFICATION_DOCS.accreditedInvestor,
  'faq-disclosures': ACCOUNT_VERIFICATION_DOCS.accreditedInvestorDisclosures,
  'faq-ecp': ACCOUNT_VERIFICATION_DOCS.eligibleContractParticipant,
  ecpEvidenceInfoLink: ACCOUNT_VERIFICATION_DOCS.acceptableEcpEvidence,
  tradingAuthInfoLink: ACCOUNT_VERIFICATION_DOCS.tradingAuthorization,
  'firm-trading-authorization-form':
    ACCOUNT_VERIFICATION_DOCS.firmTradingAuthorizationForm,
  'faq-tax-us-entity': TAX_CERTIFICATION_FAQ_URL,
  'faq-tax-non-us-entity': TAX_CERTIFICATION_FAQ_URL,
  'faq-tax-us-individual': TAX_CERTIFICATION_FAQ_URL,
  'faq-tax-non-us-individual': TAX_CERTIFICATION_FAQ_URL,
};
